import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import SendBulkTestsModal from './send_bulk_tests_modal';

const createProps = () => ({});

let props;
let wrapped: ShallowWrapper;

describe('Your description here', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<SendBulkTestsModal {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
